$(document).ready(function () {
  document.querySelector('.skip-to-content-link').addEventListener('click', function (e) {
      const target = document.getElementById('MainContent');
      let floatingMenu = document.querySelector('.menu-container');
      if (target) {
        target.setAttribute('tabindex', '-1'); // ensure it's still set
        target.focus();
      }
      if (floatingMenu) {
        floatingMenu.setAttribute('position', 'sticky');
      }
  });
});

/* SLIDEUP ANIMATION SCRIPT */

var $animation_elements = $(".slide-up, .animation-element");
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;

  $.each($animation_elements, function () {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top - 100;
    var element_bottom_position = element_top_position + element_height;

    if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
      $element.addClass("in-view");
    }
  });
}

window.onload = check_if_in_view;
$window.on("scroll resize", check_if_in_view);

/* ACCORDION SCRIPT */

var $accordion = $("#accordion");

$accordion.accordion({
  active: true,
  header: ".acheader",
  collapsible: "true",
  heightStyle: "content",
});

$(".opener").on("click", function () {
  var toOpen = $(this).data("panel"),
    toElmnt = $(this).attr("href");

  $("html, body").animate(
    {
      scrollTop: $(toElmnt).offset().top - 84,
    },
    2000,
    function () {
      $accordion.accordion("option", "active", toOpen);
    },
  );

  return false;
});

/* SMOOTH SCROLL SCRIPT */

$(document).on("click", 'a[href^="#"]', function (event) {
  event.preventDefault();

  const targetId = $(this).attr("href");
  const $target = $(targetId);

  if ($target.length) {
    const offset = -1;
    $("html, body").animate(
      {
        scrollTop: $target.offset().top + offset,
      },
      500,
      function () {
        // Ensure the target can be focused
        if (!$target.is(":focusable")) {
          $target.attr("tabindex", "-1");
        }
        $target.focus();

        // Run your visibility check
        check_if_in_view();
      }
    );
  }
});

/* PRODUCT CAROUSEL SCRIPT */

const carouselSlide = (e, direction) => {
  const carouselDiv = e.closest(".carousel").querySelector(".carousel-boxes");
  if (carouselDiv) {
    let times = 0;
    let boxSize = 400;
    let scrollAmount = boxSize * direction;
    const pageWidth = document.documentElement.scrollWidth;

    if (pageWidth < 1260) {
      let scrollAmount = 396 * direction;
      carouselDiv.scroll({
        left: carouselDiv.scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    } else {
      carouselDiv.scroll({
        left: carouselDiv.scrollLeft + scrollAmount * 3,
        behavior: "smooth",
      });
    }

    setTimeout(function () {
      const backwardBtn = e.closest(".carousel").querySelector(".left");
      if (direction === -1 && carouselDiv.scrollLeft <= 0) {
        backwardBtn.style.display = "none";
      } else {
        backwardBtn.style.display = "flex";
      }
    }, 825);

    setTimeout(function () {
      const forwardBtn = e.closest(".carousel").querySelector(".right");
      if (direction === 1 && carouselDiv.scrollLeft + carouselDiv.clientWidth >= carouselDiv.scrollWidth) {
        forwardBtn.style.display = "none";
      } else {
        forwardBtn.style.display = "flex";
      }
    }, 825);
  }
};

/* LEGACY MODAL SCRIPT */
$(document).ready(function () {
  var scrollPosition;

  $(".trigger").click(function openPopup() {
    scrollPosition = window.pageYOffset;
    console.log(scrollPosition);
    var selectedTile = $(this).attr("id");
    $(".hpstr-element__modal." + selectedTile)
      .delay(100)
      .fadeIn(300);
    $(".hpstr-element__modal." + selectedTile).addClass("open");
    $("html").css("top", "-" + scrollPosition + "px");

    if ($(window).width() < 575) {
      $("html").css({ overflow: "hidden", position: "" });
    } else {
      $("html").css({ overflow: "hidden" });
    }
  });

  const closePopup = function () {
    if ($(".hpstr-element__modal").hasClass("open")) {
      $(".hpstr-element__modal").fadeOut(200);
      $(".hpstr-element__modal").removeClass("open");
      $("html").css({ position: "", overflow: "", top: "" });
      window.scrollTo(0, scrollPosition);
    }
  };

  $(".sticky-close").click(closePopup);
  $(".hpstr-element__modal").click(closePopup);
  $(".page-header").click(closePopup);

  $(".hpstr-element__modal-content").click(function (event) {
    event.stopPropagation();
  });
  $(".trigger").click(function (event) {
    event.stopPropagation();
      if (floatingMenu) {
        floatingMenu.setAttribute('position', 'sticky');
      }
  });
});